/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { MutableRefObject } from 'react';
import { Merge } from 'type-fest';

export type DocumentedPropsWithChildren<P> = P & {
    /** Контент */
    children?: React.ReactNode;
};

export interface ComponentPropsWithElement {
    Element?: keyof JSX.IntrinsicElements;
}
/*
 * Данный тип позволяет объединять параметры компонента
 * с параметрами дочернего компонента или html элемента
 */
export type WithCustomElementHelper<CP extends ComponentPropsWithElement, ET> = DocumentedPropsWithChildren<
    ET extends React.ComponentType<infer U>
        ? { Element?: ET } & Omit<Merge<CP, U>, 'Element'>
        : ET extends Extract<CP['Element'], keyof JSX.IntrinsicElements>
        ? { Element?: ET } & Merge<JSX.IntrinsicElements[ET], Omit<CP, 'Element'>>
        : CP
>;

/**
 * Данный интерфейс позволяет создавать компоненты
 * с возможностью задавать кастомный HTML-элемент
 * либо React-компонент и использовать его свойства.
 */
export interface ComponentWithCustomElement<
    ComponentProps extends ComponentPropsWithElement,
    DefaultElement extends ComponentProps['Element'] | React.ComponentType<any>
> {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
    <T extends any = DefaultElement>(props: WithCustomElementHelper<ComponentProps, T>): ReturnType<React.FC>;
    displayName?: string;
}

// eslint-disable-next-line
export type InnerRef = MutableRefObject<any>;

/**
 * Тип TupleOf позволяет генерировать кортеж
 * из заданного количества элементов
 * определенного типа
 * (алгоритм с линейной сложностью, можно потенциально
 * заменить на логарифмическую, но тип заметно усложнится)
 */
type TupleOfElements<T, N extends number, R extends unknown[]> = R['length'] extends N
    ? R
    : TupleOfElements<T, N, [...R, T]>;

export type TupleOf<T, N> = N extends number ? TupleOfElements<T, N, []> : never;
